



































import {Vue, Component, Prop} from 'vue-property-decorator';
import {ServiceRecordDTO} from "@/components/payroll/business/services/ServiceDTO";
import moment from "moment/moment";
import Application from "@/state/Application";
import {EMPTY_PAGE} from "@/dto/taxation/Page";
import DeleteConfirmation from "@/components/payroll/business/DeleteConfirmation.vue";
import ServiceLogOrchestrator from "@/services/ServiceLogOrchestrator";
import {processError} from "@/utils/ComponentUtils";

export type ServiceLogViewSide = "CONTRACTOR" | "EMPLOYER"
type Mode = "SHORT" | "FULL";

@Component({
	computed: {
		moment() {
			return moment
		}
	}
})
export default class ServiceLogView extends Vue {

	@Prop()
	private log!: ServiceRecordDTO

	@Prop()
	private side!: ServiceLogViewSide

	@Prop({default: true})
	private disablable!: boolean

	@Prop({default: true})
	private mutable!: boolean

	private mode: Mode = "SHORT"

	@Prop()
	private preDisable!: (record: ServiceRecordDTO) => void;

	@Prop()
	private callback!: () => void

	toEdit() {
		this.$emit("edit", this.log)
	}

	disable() {
		this.$emit("disable", this.log)
	}
}
